// extracted by mini-css-extract-plugin
export default {"approvalBox":"ApprovalNote_approvalBox__OInMK"};